(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-intelligence]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const input = root.querySelector('[data-search]');
      const clear = root.querySelector('[data-clear]');
      const status = root.querySelector('[data-results]');
      const empty = root.querySelector('[data-empty]');
      const chapters = [...root.querySelectorAll('[data-chapter]')];
      const answers = [...root.querySelectorAll('[data-answer]')];
      const normalise = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      const index = new Map(answers.map(answer => [answer, normalise(answer.textContent)]));
      let previousOpen = null;
      const filter = () => {
        const words = normalise(input.value.trim()).split(/\s+/).filter(Boolean);
        if (words.length && previousOpen === null) previousOpen = new Set(answers.filter(answer => answer.open));
        let count = 0;
        answers.forEach(answer => {
          const matches = words.every(word => index.get(answer).includes(word));
          answer.hidden = !matches;
          if (matches) count++;
          if (words.length) answer.open = matches;
          else if (previousOpen !== null) answer.open = previousOpen.has(answer);
        });
        if (!words.length) previousOpen = null;
        chapters.forEach(chapter => {
          const visible = [...chapter.querySelectorAll('[data-answer]')].some(answer => !answer.hidden);
          chapter.hidden = !visible;
          root.querySelectorAll('[data-topic-link]').forEach(link => {
            if (link.dataset.topicLink === chapter.dataset.chapter) link.hidden = !visible;
          });
        });
        clear.hidden = !words.length;
        empty.hidden = count !== 0;
        status.textContent = words.length ? (count === 1 ? root.dataset.countOne : root.dataset.countLabel.replace('[count]', String(count))) : '';
        root.classList.toggle('inf-intel--searching', words.length > 0);
      };
      input.addEventListener('input', filter);
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { input.value = ''; filter(); }
      });
      const revealHash = () => {
        const target = document.getElementById(location.hash.slice(1));
        if (!target || !root.contains(target)) return;
        if (input.value) { input.value = ''; filter(); }
        if (target.matches('[data-answer]')) target.open = true;
        requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
      };
      window.addEventListener('hashchange', revealHash);
      root.querySelector('[data-finder]').hidden = false;
      if (location.hash) revealHash();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
